import '../../publicPath';

import loadPolyfills from '../2-polyfill';

import { bootstrap as authBootstrap } from './auth';

void (async () => {
  await loadPolyfills();
  await authBootstrap();
})();
